import EditAssignmentsContentPanel from './EditAssignmentsContentPanel';
export default EditAssignmentsContentPanel;
